export class Optional<T> {
  value: T | undefined

  get isPresent () {
    return this.value !== undefined
  }

  constructor (value: T | undefined) {
    this.value = value
  }

  get (): T {
    if (this.value !== undefined) {
      return this.value
    }
    throw new Error('NoSuchElementException')
  }

  ifPresent (consumer: (value: T) => void): Optional<T> {
    if (this.value !== undefined) {
      consumer(this.value)
    }
    return this
  }

  async ifPresentAsync (consumer: (value: T) => Promise<void>): Promise<Optional<T>> {
    if (this.value !== undefined) {
      await consumer(this.value)
    }
    return this
  }

  ifPresentOrElse (consumer: (value: T) => void, action: () => void) {
    if (this.value !== undefined) {
      consumer(this.value)
    } else {
      action()
    }
    return this
  }

  orElse (other?: T): T | undefined {
    return this.value !== undefined ? this.value : other
  }

  static of<T> (value: T): Optional<T> {
    return new Optional(value)
  }

  static ofNullable<T> (value: T | undefined): Optional<T> {
    return new Optional(value)
  }
}
